import { render, staticRenderFns } from "./modalCompraIngreso.vue?vue&type=template&id=3e52af7c&scoped=true"
import script from "./modalCompraIngreso.vue?vue&type=script&lang=js"
export * from "./modalCompraIngreso.vue?vue&type=script&lang=js"
import style0 from "./modalCompraIngreso.vue?vue&type=style&index=0&id=3e52af7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e52af7c",
  null
  
)

export default component.exports